import React from "react";

import CustomIcon from "../customIcon";

const TextIcon = ({ text, type, color, title }) => (
  <span>
    <CustomIcon type={type} color={color} title={title} marginRight={10} />
    {text}
  </span>
);

export default TextIcon;
